import * as React from 'react';

export function GoalRateDisplay({ weeklyRate }: { weeklyRate: number; }) {
	return (
		<span>
			{`${Math.ceil(weeklyRate / 7)}↓ `}
			{`/${weeklyRate < 0.01 ? 0 : weeklyRate}`}
		</span>
	);
}
